import React, { useEffect } from 'react';
import NoData from 'components/commonComponents/Nodata/index';
import { Button, Divider, Result, Typography } from 'antd';

// import './globalOverrider.css';

const { Title } = Typography;
import ChatBox from '../components/Webchat/ChaBox';
import ConversationSelectionSider from '../components/Webchat/ConversationSelectionSider';
import WebChatMainSider from '../components/Webchat/WebChatMainSider';
import { useSelector } from 'react-redux';
import { setTeamMembers } from '../../../reduxToolkit/inboxSlice';
import { useDispatch } from 'react-redux';
import { ICONS } from '../../../assets/icons';
import { Loading3QuartersOutlined, LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const WebChat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    selectedWebChatTeam,
    selectedWebChatConversation,
    webChatConversationMessagesLoading,
  } = useSelector((state) => state?.inbox);
  const { featureFlags } = useSelector((state) => state.app);

  if (!featureFlags.webchat_feature) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button
            onClick={() => {
              navigate('/user/home');
            }}
            type="primary"
          >
            Back Home
          </Button>
        }
      />
    );
  }
  // Handle Functions
  // const listTeamMembers = () => {
  //   dispatch(
  //     fetchTeamMembers({
  //       brand_id: currentBrand?.brand_id,
  //       team_id: selectedWebChatTeam?.team_id,
  //     }),
  //   );
  // };

  // useEffects
  useEffect(() => {
    // if (!selectedWebChatTeam?.team_id) return;
    // const lastSelectedWebChatTeam = localStorage.getItem(
    //   'lastSelectedWebChatTeam',
    // );
    // if (
    //   selectedWebChatTeam?.team_id != lastSelectedWebChatTeam ||
    //   teamMembers.length === 0
    // ) {
    //   listTeamMembers();
    // }

    // localStorage.setItem(
    //   'lastSelectedWebChatTeam',
    //   selectedWebChatTeam?.team_id,
    // );
    if (selectedWebChatTeam?.team_id) {
      dispatch(setTeamMembers());
    }
  }, [selectedWebChatTeam]);

  return (
    <div className="grid h-screen grid-cols-[minmax(230px,1fr)_minmax(280px,1fr)_minmax(750px,8fr)] bg-gray-100 relative">
      {/* First side bar */}
      <div className="h-dvh overflow-y-scroll bg-white pb-5  border-r border-gray-200">
        <div className="sticky top-0 bg-white">
          <Title
            level={4}
            style={{ margin: 0 }}
            className="text-[var(--textBlack)] mb-[0] px-2 py-5 pb-2 ps-4"
          >
            WebChat
          </Title>
          <Divider style={{ margin: 0 }} />
        </div>

        <WebChatMainSider />
      </div>

      {/* second sidebar */}
      <ConversationSelectionSider />

      {/* Main contents */}
      {selectedWebChatConversation?.id ? (
        <ChatBox />
      ) : webChatConversationMessagesLoading ? (
        <div className="flex items-center justify-center h-dvh">
          <Loading3QuartersOutlined spin style={{ fontSize: '50px' }} />
        </div>
      ) : (
        <div className={`bg-gray-25 flex flex-col`}>
          <NoData
            icon={ICONS?.inboxEmpty}
            title="There are no messages yet."
            iconStyle={'w-[10vw]'}
            style={'max-w-[25vw]'}
            titleClassName="!font-largest"
          />
        </div>
      )}
    </div>
  );
};

export default WebChat;
